import { FC, useEffect } from "react";
import SimpleCard from "../common/simple-card";
import FlexBox from "../common/flex-box";
import { toFriendlyTime } from "../../utils/date-utils";
import useClock from "lib/hooks/useClock";

interface TimeRemainingProps {
  timeRemainingInMins: number;
  onTick: VoidFunction;
}

const TimeRemaining: FC<TimeRemainingProps> = ({
  timeRemainingInMins,
  onTick,
}) => {

  useEffect(() => {
    let timeoutHandle = setTimeout(onTick, 60000);

    // if (timeRemainingInMins > 0) {
    //   timeoutHandle = setTimeout(onTick, 60000);
    // }

    return () => {
      timeoutHandle = null;
    }
  }, [timeRemainingInMins]);

  if (timeRemainingInMins <= 0) {
    return (
      <SimpleCard title="All done!">
        <p>No new appointments</p>
      </SimpleCard>
    );
  }

  return (
    <SimpleCard title="Time remaining" isShowAnimation>
      <FlexBox direction="column" alignItems="center">
        <h1 className="display-3">{toFriendlyTime(timeRemainingInMins)}</h1>
        <p>Time to next appointment</p>
      </FlexBox>
    </SimpleCard>
  );
};

export default TimeRemaining;
